/**
 * Logger utility to centralize application logging.
 * Can be easily extended to route logs to external services like Sentry.
 */

/* eslint-disable no-console */

const logger = {
  log: (...args) => {
    // In production, you might want to suppress these or send to a log aggregator
    if (process.env.NODE_ENV !== 'production') {
      console.log(...args);
    }
  },
  error: (...args) => {
    // Centralized error handling
    console.error(...args);

    // TODO: Integrate with Sentry or other error tracking services
    // if (process.env.NODE_ENV === 'production') {
    //     Sentry.captureException(args[0]);
    // }
  },
  warn: (...args) => {
    if (process.env.NODE_ENV !== 'production') {
      console.warn(...args);
    }
  },
  info: (...args) => {
    if (process.env.NODE_ENV !== 'production') {
      console.info(...args);
    }
  },
};

export default logger;
